module.exports = __webpack_public_path__ + "img/face-emoticon9.fd8c5566.svg";